<template>
  <div id="autocomplete">
    <div class="autocomplete">
      <b-form-input v-model="searchi18n"
                    id="search-services"
                    placeholder="Type anything..."
                    @keyup.down="onArrowDown"
                    @keyup.up="onArrowUp"
                    @keyup.enter="onEnter"
                    @input="onChange"
                    v-b-tooltip.hover title="Start typing a service"></b-form-input>

      <ul id="autocomplete-specialities" v-if="!_.isEmpty(specialitiesResultsi18n)" v-show="isOpen" class="autocomplete-results autocomplete-specialities">
        <li>
          <h6 class="mt-3 mb-3">Suggested categories</h6>
        </li>
        <li class="loading" v-if="isLoading">
          Loading results...
        </li>
        <li v-else
            v-for="(result, index) in specialitiesResultsi18n"
            :key="index"
            @click="setResult(index, 'specialities')"
            class="autocomplete-result"
            :class="{ 'is-active': index === arrowCounter }">
          <strong>{{ result }}</strong>
        </li>
      </ul>

      <ul id="autocomplete-services" v-if="!_.isEmpty(servicesResultsi18n)" v-show="isOpen" class="autocomplete-results autocomplete-services">
        <li>
          <h6 class="mt-3 mb-3">Suggested services</h6>
        </li>
        <li class="loading" v-if="isLoading">
          Loading results...
        </li>
        <li v-else
            v-for="(result, index) in servicesResultsi18n"
            :key="index"
            @click="setResult(index, 'services')"
            class="autocomplete-result"
            :class="{ 'is-active': index === arrowCounter }">
          <strong>{{ result.mainKey }}</strong> - {{ result.subKey }}
        </li>
      </ul>
      <div v-else-if="_.isEmpty(servicesResultsi18n) && _.isEmpty(professionals)" id="services-list" class="autocomplete-results autocomplete-services">
        <h6 class="mt-3 mb-3">Choose a service</h6>
        <b-card no-body class="mb-2" :key="key1" v-for="(value, key1) in servicesObject">
          <b-card-header header-tag="header">
            <b-btn class="main-level d-flex" block href="#" v-b-toggle="key1" variant="secondary">
              <div class="d-inline-block">{{ $t(`services.${key1}`) }}</div>
              <i class="d-inline-flex material-icons">expand_more</i>
            </b-btn>
          </b-card-header>
          <b-collapse :id="key1">
            <b-card-body class="third-level">
              <b-row class="card-text" v-if="!_.isEmpty(value.children)">
                <b-col cols="6" :key="key2" v-for="(value2, key2) in value.children">
                  <a class="third-level" href="#" @click.prevent="addToSearch(key1, key2)">
                    {{ $t(`services.${key2}`) }}
                  </a>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>

      <ul id="autocomplete-professionals" v-if="_.isEmpty(servicesResultsi18n) && _.isEmpty(specialitiesResultsi18n) && !_.isEmpty(professionals)" v-show="isOpen" class="autocomplete-results autocomplete-professionals">
        <li>
          <h6 class="mt-3 mb-3">Suggested professionals</h6>
        </li>
        <li class="loading" v-if="isLoading">
          Loading professionals...
        </li>
        <li v-else
            v-for="(result, index) in professionals"
            :key="index"
            class="autocomplete-result"
            :class="{ 'is-active': index === arrowCounter }">
          <router-link :to="{ name: `ProfessionalsSingle.${$i18n.i18next.language}`, params: { slug: result.slug } }">
            <b-row>
              <b-col cols="4" lg="3" class="photo-wrapper">
                <avatar class="profile" size="70px" :userName="result.first_name+' '+result.last_name" :userImage="result.image"></avatar>
              </b-col>
              <b-col cols="8" lg="9" class="">
                <div class="title">
                  <strong>{{ result.first_name }} {{ result.last_name }}</strong>
                  <ratings :rating="result.rating" :count="result.rating_count"></ratings>
                </div>
              </b-col>
            </b-row>
          </router-link>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/app/global/components/Avatar'
import Ratings from '@/app/global/components/Ratings'

export default {
  name: 'autocomplete',
  props: {
    services: {
      type: Object,
      required: false,
      default: () => {}
    },
    specialities: {
      type: Array,
      required: false,
      default: () => []
    },
    professionals: {
      type: Array,
      required: false,
      default: () => []
    },
    inputText: {
      type: String,
      required: false,
      default: ''
    }
  },
  components: {
    Avatar,
    Ratings
  },
  data () {
    return {
      isOpen: false,
      servicesResults: [],
      servicesResultsi18n: [],
      specialitiesResults: [],
      specialitiesResultsi18n: [],
      search: '',
      searchi18n: '',
      isLoading: false,
      arrowCounter: -1,
      globalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      servicesObject: 'account/services'
    })
  },
  methods: {
    onChange () {
      if (this.searchi18n === '') {
        this.servicesResults = ''
        this.servicesResultsi18n = ''
        // this.specialitiesResults = ''
        // this.specialitiesResultsi18n = ''
      } else {
        this.filterResults()
        this.isOpen = true
        ++this.globalCount
        // console.log(this.globalCount)
      }

      this.$emit('input', this.searchi18n)
    },
    filterResults () {
      let servicesArr = []
      let servicesArri18n = []
      let servicesObj = this.services
      for (var key in servicesObj) {
        let mainKey = key

        let subLevelObj = servicesObj[key]

        if (!_.isEmpty(subLevelObj.children)) {
          subLevelObj = subLevelObj.children
          for (var key in subLevelObj) {
            let subKey = key
            servicesArr.push({ mainKey: mainKey, subKey: subKey })
            servicesArri18n.push({ mainKey: this.$i18n.t(`services.${mainKey}`), subKey: this.$i18n.t(`services.${subKey}`) })
          }
        }
      }

      this.servicesResults = _.filter(servicesArr, item => {
        return item.subKey.indexOf(this.search) > -1
      })

      this.servicesResultsi18n = _.filter(servicesArri18n, item => {
        return item.subKey.toLowerCase().indexOf(this.searchi18n.toLowerCase()) > -1
      })

      let specialitiesSrc = this.specialities
      let specialitiesArr = []
      let specialitiesArri18n = []
      let parent = this
      specialitiesSrc.forEach(function (val) {
        specialitiesArr.push(parent.$i18n.t(`specialities.${val.name}`))
        specialitiesArri18n.push(parent.$i18n.t(`specialities.${val.name}`))
      })

      this.specialitiesResults = _.filter(specialitiesArr, item => {
        return item.indexOf(this.search) > -1
      })

      this.specialitiesResultsi18n = _.filter(specialitiesArri18n, item => {
        return item.toLowerCase().indexOf(this.searchi18n.toLowerCase()) > -1
      })
    },
    setResult (index, type) {
      switch (type) {
        case 'services':
          // this.search = `${this.servicesResults[index].mainKey} - ${this.servicesResults[index].subKey}`
          this.searchi18n = `${this.servicesResultsi18n[index].mainKey} - ${this.servicesResultsi18n[index].subKey}`
          // this.searchi18n = this.servicesResultsi18n[key].replace(/<\/?strong>/g, '')
          this.$router.push({ name: `Professionals.${this.$i18n.i18next.language}`, params: { search: this.searchi18n, location: this.location }})
          break
        case 'specialities':
          this.searchi18n = `${this.specialitiesResultsi18n[index]}`
          break
      }
      this.isOpen = false
    },
    onArrowDown (evt) {
      if (this.arrowCounter < this.servicesResults.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp () {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },
    onEnter () {
      this.search = this.servicesResults[this.arrowCounter];
      this.isOpen = false
      this.arrowCounter = -1;
    },
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  },
  watch: {
    services: function (val, oldValue) {
      if (val.length !== oldValue.length) {
        this.servicesResults = val
        this.isLoading = false;
      }
    },
    specialities: function (val, oldValue) {
      if (val.length !== oldValue.length) {
        this.specialitiesResults = val
        this.isLoading = false;
      }
    },
    inputText: function (val, oldValue) {
      this.searchi18n = this.inputText
    }
  },
  mounted () {
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed () {
    document.removeEventListener("click", this.handleClickOutside);
  }
}
</script>

<style lang="scss" scoped>
  .autocomplete {
    position: relative;
    width: 100%;

    #search-services {
      padding-right: 2.5rem;
    }
  }

  .autocomplete-results {
    position: absolute;
    top: 2.5rem;
    left: 0;
    padding: 0;
    margin: 0;
    border: 1px solid #eeeeee;
    height: 300px;
    overflow: auto;
    width: 50%;
    background: white;
    z-index: 999;

    &.autocomplete-specialities {
      left: 0;
      width: 50%;
    }

    &.autocomplete-services {
      left: 50%;
      width: 100%;
    }

    &.autocomplete-professionals {
      left: 0%;
      width: 100%;

      a {
        color: inherit !important;
      }
    }
  }

  .autocomplete-result {
    width: 100%;
    list-style: none;
    text-align: left;
    padding: 4px 2px;
    cursor: pointer;
  }

  .autocomplete-result.is-active,
  .autocomplete-result:hover {
    background-color: #4aae9b;
    color: white;
  }

  #services-list {
    .card {
      border: none;
      border-radius: 0;
    }
    header {
      padding: 0;
      background: transparent;
      border: none;
      border-radius: 0;
    }
    .btn.main-level {
      color: inherit;
      white-space: normal;
      border: none;
      border-radius: 0;
      border-bottom: 2px solid black;
      text-align: left;
      box-shadow: none;
      background: transparent;
    }
    .btn.second-level {
      color: white;
      border: none;
      box-shadow: none;
    }
    .card-body.third-level {
      padding: 0.5rem 0;

      a.third-level {
        display: block;
        color: black;
        padding: 0.5rem 0;
        border-bottom: 1px solid black;
        white-space: normal;
      }
    }
  }
</style>
